<rnpl-action-card
  [title]="title || banner?.title"
  [description]="description || banner?.description"
  [buttonConfig]="banner?.buttonConfig"
  [styles]="banner?.styles"
  [imgRight]="imgRight"
  (buttonClicked)="localeService.goToGetStarted()">
</rnpl-action-card>
